import SEO, { pageSEO } from "../components/seo.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faHouse,
  faDollarSign,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";


export default function Calculator() {

  const seoConfig = pageSEO.calculator();

  const cards = [
    {
      icon: faCalculator,
      title: "Estimate Payments",
      text: "Calculate your expected monthly mortgage payments and understand your affordability."
    },
    {
      icon: faDollarSign,
      title: "Plan Your Budget",
      text: "Explore different down payments, rates, and loan terms before making decisions."
    },
    {
      icon: faHouse,
      title: "Smart Home Buying",
      text: "Know your numbers and approach your next purchase with confidence."
    }
  ];

  return (
    <>
      <SEO {...seoConfig} />

      {/* HERO */}
      <section className="relative overflow-hidden bg-light/20 pt-40 pb-32">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mx-auto max-w-[1400px] px-6 lg:px-16"
        >
          <div className="mb-16">
            <motion.p
              variants={fadeUp}
              className="text-xs uppercase tracking-[0.6em] text-gray-600"
            >
              Why Use Our Calculator
            </motion.p>

            <motion.h2
              variants={fadeUp}
              className="mt-6 font-heading2 text-5xl text-neutral-800 lg:text-6xl"
            >
              Tools For Smarter
              <br />
              Home Decisions
            </motion.h2>
          </div>

          <div className="grid gap-8 md:grid-cols-3">
            {
              cards.map((card, index) => (
                <motion.div
                  key={index}
                  variants={fadeUp}
                  whileHover={{ y: -10 }}
                  className="group relative overflow-hidden border border-accent/50 bg-white p-10 transition "
                >
                  <div className="flex h-16 w-16 items-center justify-center bg-light transition group-hover:bg-accent/50 ">
                    <FontAwesomeIcon
                      icon={card.icon}
                      className="text-xl text-accent transition group-hover:text-white"
                    />

                  </div>

                  <h3 className="mt-8 font-serif text-3xl text-neutral-800">
                    {card.title}
                  </h3>

                  <p className="mt-5 leading-8 text-gray-800">
                    {card.text}
                  </p>
                </motion.div>
              ))
            }
          </div>
        </motion.div>
      </section>

      {/* CALCULATOR */}
      <motion.section
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="relative overflow-hidden bg-light py-28"
      >
        <div className="mx-auto max-w-[1400px] px-6 lg:px-16">
          <div
            className="overflow-hidden border border-accent/50 bg-white shadow-lg"
          >
            {/* HEADER */}
            <div
              className="flex flex-col gap-8 border-b border-gray-200 px-8 py-12 lg:flex-row lg:items-end lg:justify-between lg:px-14 "
            >
              <div>
                <p
                  className="text-xs uppercase tracking-[0.5em] text-gray-600"
                >
                  Home Financing
                </p>

                <h2
                  className="mt-6 font-heading2 text-5xl text-neutral-800"
                >
                  Mortgage Payment
                  <br />
                  Calculator
                </h2>

                <p
                  className="mt-6 max-w-2xl leading-8 text-gray-700"
                >
                  Adjust your home value, down payment,
                  interest rate, and loan duration to
                  create a clearer financial picture.
                </p>
              </div>

              <div
                className="flex h-20 w-20 items-center justify-center border border-accent/50"
              >
                <FontAwesomeIcon
                  icon={faCalculator}
                  className="text-2xl text-accent"
                />
              </div>
            </div>

            {/* IFRAME */}
            <div className="bg-white">
              <iframe
                src="https://www.mortgagecalculator.org/webmasters/?downpayment=80000&homevalue=400000&loanamount=320000&interestrate=7&loanterm=30&propertytax=2700&pmi=1&homeinsurance=1500&monthlyhoa=0"
                className="h-[2400px] w-full border-0 md:h-[1200px]"
                scrolling="no"
                title="Mortgage Calculator"
              />
            </div>
          </div>
        </div>
      </motion.section>
    </>
  );
}